import { render, staticRenderFns } from "./RequestsPage.vue?vue&type=template&id=4e831801&scoped=true"
import script from "./RequestsPage.vue?vue&type=script&lang=js"
export * from "./RequestsPage.vue?vue&type=script&lang=js"
import style0 from "./RequestsPage.vue?vue&type=style&index=0&id=4e831801&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e831801",
  null
  
)

export default component.exports